import React from 'react';
import { ApolloError } from 'apollo-client';
import { Query } from 'react-apollo';
import moment from 'moment-timezone';
import { isNotNullOrUndefined } from 'types/typescript/util';
import AVAILABLE_COACHING_SESSIONS_QUERY from 'coaching/queries/AvailableCoachingSessions.gql';
import { AvailableCoachingSessions } from 'coaching/queries/__generated__/AvailableCoachingSessions';

export type CoachingReservation = {
  coachUuid: string;
  startDateTime: moment.Moment;
  endDateTime: moment.Moment;
};

export type SavedCoachingReservation = CoachingReservation & {
  reservationUuid: string;
  expiresAt: string;
};

export type CoachingTimeOff = {
  startDate: moment.Moment;
  endDate: moment.Moment;
};

export type Props = {
  subjects: string[];
  startDateTimeRange: string;
  endDateTimeRange: string;
  children: (props: {
    reservations?: CoachingReservation[];
    timeOff?: CoachingTimeOff[];
    loading: boolean;
    error?: ApolloError;
  }) => React.ReactNode;
};

export default function AvailableCoachingSessionsContainer(props: Props) {
  return (
    <Query<AvailableCoachingSessions>
      query={AVAILABLE_COACHING_SESSIONS_QUERY}
      variables={{
        subjects: props.subjects,
        startDateTimeRange: props.startDateTimeRange,
        endDateTimeRange: props.endDateTimeRange,
      }}>
      {({ loading, error, data }) => {
        return props.children({
          reservations: data?.coaching_availableCoachingSessions?.availableSessions
            .filter(isNotNullOrUndefined)
            .map(res => ({
              coachUuid: res.coachUuid,
              startDateTime: moment(res.startDateTime),
              endDateTime: moment(res.endDateTime),
            })),
          timeOff: data?.coaching_availableCoachingSessions?.timeOff
            .filter(isNotNullOrUndefined)
            .map(res => ({
              startDate: moment(res.startDate),
              endDate: moment(res.endDate),
            })),
          loading,
          error,
        });
      }}
    </Query>
  );
}
